import React, { useEffect, useState } from "react";
import {
  MdSettings,
  MdHeadsetMic,
  MdPrivacyTip,
  MdOutlineLogout,
  MdDelete,
} from "react-icons/md";
import { signOut } from "store/services/Authentication";
import { fcmforWebConstant } from "constants";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "../../firebase";
import { logoutUser } from "store/reducers/Authentication";
import { useNavigate } from "react-router-dom";
import {
  deleteUserProfile,
  getUserProfile,
} from "store/services/Profile/profile";
import { setProfile } from "store/actions/Profile/profile";
import altImage from "assets/altImage.png";
import Modal from "./components/Modal";
import Loader from "components/Loader";
import { mavenceryPrivacyPolicy } from "constants";

const Profile = () => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);
  const { currentUser } = auth;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteConfrim, setIsDeleteConfrim] = useState(false);

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
    setIsDeleteConfrim(!isDeleteConfrim);
  };

  useEffect(() => {
    if (user) {
      const fetchUserProfile = async () => {
        try {
          const profile = await getUserProfile(user.accessToken, user.data.id);
          if (profile.success) {
            setUserProfile(profile.data);
            dispatch(setProfile(profile.data));
          }
        } catch (error) {
          console.error(error);
        } finally {
          setLoading(false);
        }
      };
      fetchUserProfile();
    }
  }, [dispatch, user]);

  const handleLogout = async () => {
    const data = {
      firebaseId: currentUser?.uid,
      deviceId: fcmforWebConstant(),
    };
    const result = await signOut(user.accessToken, data);
    if (result.success) {
      if (selectedStore?.isWhiteLabel) {
        navigate(`/${selectedStore.id}`);
      } else {
        navigate("/mav");
      }
      localStorage.removeItem("userState");
      localStorage.removeItem("storeState");
      await auth.signOut();
      dispatch(setProfile({}));
      dispatch(logoutUser());
    }
  };

  const modalData = {
    title: "Confirm Account Deletion",
    description:
      "This action will permanently delete your account and all associated data. Are you absolutely sure you want to proceed?",
    label: "List Name",
    redButton: "CANCEL",
    purpleButton: "CONFRIM",
  };
  const handleOpenModal = () => {
    handleModalToggle();
  };
  const handleDeleteHandler = async () => {
    setIsDeleteConfrim(true);

    const data = {
      firebaseId: currentUser.uid,
      deviceId: fcmforWebConstant(),
    };
    try {
      if (isDeleteConfrim) {
        if (currentUser) {
          const result = await deleteUserProfile(
            user.accessToken,
            user.data.id,
            data
          );
          if (result.success) {
            navigate("/");
            localStorage.removeItem("userState");
            localStorage.removeItem("storeState");
            await auth.signOut();
            dispatch(setProfile({}));
            dispatch(logoutUser());
          }
        }
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const CardItem = ({ Icon, text, bgColor, onClickHandler }) => {
    return (
      <div
        onClick={onClickHandler}
        className="flex items-center gap-4 pb-2 m-4 border-b-2 cursor-pointer hover:shadow-md"
      >
        <Icon
          size={30}
          style={{
            backgroundColor: bgColor,
          }}
          className={`p-1 text-white rounded-md  bg-${bgColor}`}
        />
        <h1 className="text-sm">{text}</h1>
      </div>
    );
  };
  if (loading) {
    return <Loader />;
  }
  return (
    <div className="flex flex-col items-center justify-center h-screen overflow-auto md:mt-0 lg:mt-0">
      {userProfile && (
        <div className="w-full mt-8 font-bold image-wrapper">
          <div className="flex justify-center ">
            <img
              className="border rounded-full w-44 h-44"
              src={userProfile.photo_url ? userProfile.photo_url : altImage}
              alt={"ProfilePicture"}
            />
          </div>
          <div className="items-center my-2 text-center text-gray-900">
            <h1>
              {userProfile.first_name
                ? userProfile.first_name + " " + userProfile.last_name
                : ""}
            </h1>
            <h1 className="text-gray-700">{userProfile.location}</h1>
            <h1 className="text-gray-700">{userProfile.email}</h1>
          </div>
        </div>
      )}
      <div className="flex flex-col w-full gap-3 overflow-auto font-bold text-gray-800 md:flex-row lg:flex-row justify-evenly">
        <div className="w-3/4 p-6 mx-auto border rounded-lg shadow-xl md:w-1/3 lg:w-1/3 lg:m-4 md:m-4">
          <CardItem
            onClickHandler={() =>
              navigate(`/users/${user.data.id}/updateProfile`)
            }
            bgColor={selectedStore?.theme.backgroundColor}
            Icon={MdSettings}
            text={"Account Information"}
          />
          <CardItem
            onClickHandler={() => navigate(`/users/${user.data.id}/contact`)}
            bgColor={selectedStore?.theme.backgroundColor}
            Icon={MdHeadsetMic}
            text={"Help Center"}
          />
          <CardItem
            onClickHandler={() => window.open(mavenceryPrivacyPolicy, "_blank")}
            bgColor={selectedStore?.theme.backgroundColor}
            Icon={MdPrivacyTip}
            text={"Privacy Policy"}
          />
        </div>
        <div className="w-3/4 p-6 mx-auto border rounded-lg shadow-xl md:w-1/3 lg:w-1/3 lg:m-4 md:m-4">
          <CardItem
            onClickHandler={handleLogout}
            bgColor="red-800"
            Icon={MdOutlineLogout}
            text={"Log Out"}
          />
          <CardItem
            onClickHandler={handleOpenModal}
            bgColor="red-800"
            Icon={MdDelete}
            text={"Delete Account"}
          />
        </div>
      </div>
      {isModalOpen && (
        <Modal
          modalData={modalData}
          handleModalToggle={handleModalToggle}
          isOpen={isModalOpen}
          submitHandler={handleDeleteHandler}
        />
      )}
    </div>
  );
};

export default Profile;
